import { render, staticRenderFns } from "./MaxCollectInteractionsCard.vue?vue&type=template&id=676a3247&scoped=true"
import script from "./MaxCollectInteractionsCard.vue?vue&type=script&lang=ts"
export * from "./MaxCollectInteractionsCard.vue?vue&type=script&lang=ts"
import style0 from "./MaxCollectInteractionsCard.vue?vue&type=style&index=0&id=676a3247&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676a3247",
  null
  
)

export default component.exports